module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_8-0be3bc14ada7a8e82aa861c7208c5e54.jpg";